import styled from 'styled-components'
import { theme } from 'styles/theme'
import type { ModuleVersionChange } from './profileUpdateUtils'

const ModuleVersionsList = styled.div`
    font-size: ${theme.fontSizes.small};
`

const ModuleRow = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5em;
    padding: 0.75em 1em;
    :not(:last-child) {
        border-block-end: 1px solid ${theme.colors.MediumGrey};
    }
`

const ModuleName = styled.span`
    margin-inline-end: auto;
    font-weight: ${theme.fontWeights.bold};
`

const FromVersion = styled.span`
    color: ${theme.colors.DarkGrey};
`

const ToVersion = styled.span`
    font-weight: ${theme.fontWeights.bold};
`

const Message = styled.div`
    padding: 0.75em 1em;
    color: ${theme.colors.DustGrey};
`

const MISSING_VERSION = '—'

interface ModuleVersion {
    module: string
    version: string
}

export interface ModuleVersionsProps {
    // A list of module versions, or the change of each module (old → new). null while loading.
    moduleVersions: ReadonlyArray<ModuleVersion | ModuleVersionChange> | null
    hasError: boolean
}

const isModuleVersionChange = (row: ModuleVersion | ModuleVersionChange): row is ModuleVersionChange => 'toVersion' in row

// The module versions of a profile. Only draws, see ModuleVersionsContainer for the data.
export const ModuleVersions = ({ moduleVersions, hasError }: ModuleVersionsProps) => {
    if (hasError) {
        return <Message>Error loading module versions</Message>
    }
    if (moduleVersions === null) {
        return <Message>Loading module versions...</Message>
    }
    return (
        <ModuleVersionsList>
            { moduleVersions.map(row =>
                <ModuleRow {...{ key: row.module }}>
                    <ModuleName>{ row.module }</ModuleName>
                    { isModuleVersionChange(row) ? <>
                        <FromVersion>{ row.fromVersion ?? MISSING_VERSION }</FromVersion>
                        <FromVersion>→</FromVersion>
                        <ToVersion>{ row.toVersion ?? MISSING_VERSION }</ToVersion>
                    </> :
                        <ToVersion>{ row.version }</ToVersion>
                    }
                </ModuleRow>
            ) }
        </ModuleVersionsList>
    )
}
